/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Driver_RgInputs */

const en_case_field_driver_rg = /** @type {(inputs: Case_Field_Driver_RgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID (RG)`)
};

const pt_br2_case_field_driver_rg = /** @type {(inputs: Case_Field_Driver_RgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RG`)
};

/**
* | output |
* | --- |
* | "ID (RG)" |
*
* @param {Case_Field_Driver_RgInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_driver_rg = /** @type {((inputs?: Case_Field_Driver_RgInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Driver_RgInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_driver_rg(inputs)
	return pt_br2_case_field_driver_rg(inputs)
});